module.exports = __webpack_public_path__ + "static/media/reduxIcon.46f296b2.svg";